module.exports = __webpack_public_path__ + "img/sv87.c18a46a9.svg";